import { PlaceholderPage } from '../_PlaceholderPage';
export function Configuracion() {
  return <PlaceholderPage title="Configuración" description="Datos fiscales, plantilla del PDF (logo, cabecera), plantillas de email, integraciones (futuro: ERP)." />;
}
